module.exports = __webpack_public_path__ + "120ed546b0d938f0b597fdc34074423f.svg";